import React from 'react';
import { Icon } from '../icons';

export default function Select({
  label,
  error,
  required,
  options = [],
  placeholder,
  className = '',
  wrapperClassName = '',
  ...props
}) {
  const selectId = props.id || props.name || `select-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`leading-normal ${wrapperClassName}`}>
      {label && (
        <label
          htmlFor={selectId}
          className="block text-sm font-medium text-slate-700 mb-1.5"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        <select
          id={selectId}
          className={`
            appearance-none w-full pl-3 pr-10 py-2 text-base text-slate-900
            border rounded-lg bg-white
            transition-colors
            focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500
            disabled:bg-slate-50 disabled:text-slate-500 disabled:cursor-not-allowed
            ${error ? 'border-red-300 focus:ring-red-500/50 focus:border-red-500' : 'border-slate-300'}
            ${className}
          `}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400">
          <Icon name="chevronDown" className="w-4 h-4" />
        </div>
      </div>
      {error && (
        <p className="mt-1.5 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
}
